import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '../../supabase';
import { getFingerprint } from '../../services/fingerprint';

const VisitorTracker = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    // Debounce or prevent duplicate logging for the same path if needed.
    // React.StrictMode causes double mount in dev, so we check ref.
    // However, location object changes on navigation, so we should log on location change.

    const currentPath = location.pathname + location.search;

    // Prevent logging exact duplicate paths immediately (optional, but good for React StrictMode)
    if (lastPath.current === currentPath) return;

    const logVisit = async () => {
      try {
        const searchParams = new URLSearchParams(location.search);
        const utmSource = searchParams.get('utm_source');
        const utmMedium = searchParams.get('utm_medium');
        const utmCampaign = searchParams.get('utm_campaign');

        // Wait for fingerprint if not ready yet, or proceed without it if failed/slow
        let visitorId = null;
        try {
          visitorId = await getFingerprint();
        } catch (e) {
          // Ignore
        }

        if (typeof supabase.rpc === 'function') {
            await supabase.rpc('log_visitor', {
              p_path: currentPath,
              p_referrer: document.referrer || null,
              p_user_agent: navigator.userAgent,
              p_utm_source: utmSource,
              p_utm_medium: utmMedium,
              p_utm_campaign: utmCampaign,
              p_fingerprint: visitorId
            });
        }
      } catch (error) {
        // Silently fail for analytics to not disrupt user experience
        console.warn('Failed to log visitor', error);
      }
    };

    logVisit();
    lastPath.current = currentPath;

  }, [location]);

  return null; // Renderless component
};

export default VisitorTracker;
